/*
 * @Author: along longwang6@163.com
 * @Date: 2025-02-19 14:26:43
 * @LastEditors: along longwang6@163.com
 * @LastEditTime: 2026-06-16 19:54:24
 * @FilePath: /ehr-web/src/components/UserAvatar/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useMemo } from 'react';
import { Avatar } from '@arco-design/web-react';
import { transName2Num } from '@/utils/tools';
import { AvatarProps } from '@arco-design/web-react/es/Avatar/interface';

interface IProps extends AvatarProps {
  name: string;
}
const UserAvatar = React.memo((props: IProps) => {
  const { name, style, ...other } = props;
  const avatarColor = useMemo(() => {
    const color = [
      '#33D1C9',
      '#F99057',
      '#57A9FB',
      '#8D4EDA',
      '#F9CC45',
      '#B5E241',
    ];
    return color[transName2Num(name)];
  }, [name]);
  return (
    <Avatar
      size={32}
      style={{ backgroundColor: avatarColor, ...style }}
      {...other}
    >
      &nbsp;{name?.slice(-2)}&nbsp;
    </Avatar>
  );
});
export default UserAvatar;
